import { render, staticRenderFns } from "./tabChat.vue?vue&type=template&id=4115f180&scoped=true"
import script from "./tabChat.vue?vue&type=script&lang=js"
export * from "./tabChat.vue?vue&type=script&lang=js"
import style0 from "./tabChat.vue?vue&type=style&index=0&id=4115f180&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4115f180",
  null
  
)

export default component.exports